import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://cariphs.com";
export const BRAND = "ProToCall";
export const DEFAULT_TITLE =
  "ProToCall | Construction & Property Services";
export const DEFAULT_DESCRIPTION =
  "Construction and Property Services";
export const DEFAULT_IMAGE = "https://cariphs.com/og-image.png";

/**
 * Reusable SEO head manager. Sets the document title, meta description,
 * canonical URL, Open Graph + Twitter card tags and optional JSON-LD.
 */
export const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
